
import React, { useEffect, useState } from 'react'
import Layout from './layout'
import { Link, useParams } from 'react-router-dom'
import heroDesktopBanner from "../assets/images/ForContractorsBanner.jpg"
import heroMobileBanner from "../assets/images/ForContractorsBannerMobile.jpg"
import Logo from "../assets/images/luminicoslogo.svg"
import Ourclient from '../components/Ourclient'
import clientBgImage from '../assets/images/clientBgImage.jpg'
import textBanner from '../assets/images/fecade-light.jpg'
import { FaLightbulb, FaTools } from "react-icons/fa";
import { IoShareSocialSharp } from "react-icons/io5";
import { TbStack2Filled } from "react-icons/tb";
import collabPartner from "../assets/images/collabPartner.png"
import smallBanner from "../assets/images/smallBannerDesktop.jpg"

import smallBanner2 from "../assets/images/Rectangle21.jpg"
import axios from 'axios'
import config from '../config'
import lfContent from '../JSONData/lightingFacade.json'
import { CgArrowTopRight } from 'react-icons/cg'
import FeaturedProperties2 from '../components/FeaturedProperties2'
import partnerLogo1 from '../assets/images/par1.svg'
import partnerLogo2 from '../assets/images/par2.svg'
import partnerLogo3 from '../assets/images/par3.svg'
import partnerLogo4 from '../assets/images/par4.svg'
import partnerLogo5 from '../assets/images/par5.svg'
import partnerLogo6 from '../assets/images/par6.svg'
import partnerLogo7 from '../assets/images/par7.svg'
import partnerLogo8 from '../assets/images/par8.svg'


import bannerVideo from '../assets/videos/facadeBanner.mp4'

import s1 from '../assets/images/s1.svg'
import s2 from '../assets/images/s2.svg'
import s3 from '../assets/images/s3.svg'
import s4 from '../assets/images/s4.svg'
import s5 from '../assets/images/s5.svg'
import s6 from '../assets/images/s6.svg'
import s7 from '../assets/images/s7.svg'

import s8 from '../assets/images/s8.svg'
import FeaturedPropertiesVideos from '../components/FeaturedPropertiesVideos'
import FeaturedProperties from '../components/FeaturedProperties'
import FeaturedPropertiesVideos2 from '../components/FeaturedPropertiesVideos2'
import FeaturedPropertiesVideosDisclaimer from '../components/FeaturedPropertiesVideosDisclaimer'

export const HeroBanner = ({ filePath }) => {
  if (!filePath) return null; // nothing to show

  const extension = filePath.split('.').pop().toLowerCase();
  const videoExts = ['mp4', 'webm', 'ogg', 'mov', 'avi'];

  const isVideo = videoExts.includes(extension);

  const fullPath = filePath.startsWith('http')
    ? filePath
    : `${process.env.REACT_APP_API_URL || ''}${filePath}`;

  return (
    <>
      {isVideo ? (
        <video
          className="cover"
          src={fullPath}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img className="cover" src={fullPath} alt="hero banner" />
      )}
    </>
  );
};


const LightingFacade = () => {

    const [featuredProject, setFeaturedProject] = useState([])
    const [shareholder, setShareHolder] = useState([]);
    const [facadeContent, setFacadeContent] = useState(null);
    const { lang } = useParams();
    const content = (lfContent && lfContent[lang]) ? lfContent[lang] : lfContent.en;

    const offers = content.process.map((o) => ({
        icon: o.icon === 'bulb' ? <FaLightbulb /> : o.icon === 'share' ? <IoShareSocialSharp /> : o.icon === 'tools' ? <FaTools /> : <TbStack2Filled />,
        title: o.title,
        desc: o.desc
    }));

    const partners = [
        { id: 1, logo: partnerLogo1 },
        { id: 2, logo: partnerLogo2 },
        { id: 3, logo: partnerLogo3 },
        { id: 4, logo: partnerLogo4 },
        { id: 5, logo: partnerLogo5 },
        { id: 6, logo: partnerLogo6 },
        { id: 7, logo: partnerLogo7 },
        { id: 8, logo: partnerLogo8 },
    ];
    const processIcons = {
        "s1": s1,
        "s2": s2,
        "s3": s3,
        "s4": s4,
        "s5": s5,
        "s6": s6,
        "s7": s7,
        "s8": s8,
    };
    const fetchFeaturedProjectDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-featured-projects-chronological${lang ? `?lang=${lang}` : ''}`, { withCredentials: true });
            setFeaturedProject(response.data);
        } catch (err) {
            console.log('Failed to fetch project details');
        }
    }
    const fetchShareHolderDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-shareholders${lang ? `?lang=${lang}` : ''}`, { withCredentials: true });
            setShareHolder(response.data);
        } catch (err) {
            console.log('Failed to fetch project details');
        }
    }
    const fetchFacadeData = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/facade-content${lang ? `?lang=${lang}` : ''}`, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data && response.data.data && response.data.data.length > 0) {
                setFacadeContent(response.data.data[0]);
              
            }
        } catch (err) {
            console.error('Error fetching home banner:', err);

        }
    };

    useEffect(() => {
        fetchFeaturedProjectDetails();
        fetchFacadeData()
        fetchShareHolderDetails();

    }, [lang]);
    return (
        <Layout>
            <div className="shareholder-banner image-banner hero-banner color-light d-flex flex-column justify-end gap-30 d-gap-50 full-screen position-relative top-overlay bottom-overlay">
                <picture className="cover position-absolute top-0 start-0">
                    {/* <source media="(max-width:768px)" srcSet={heroMobileBanner} />
                    <img className="cover" src={heroDesktopBanner} alt="" /> */}

                    {/* <source
                        media="(max-width:768px)"
                        srcSet={bannerVideo}
                        type="video/mp4"
                    />

                    <video
                        className="cover"
                        src={bannerVideo}
                        autoPlay
                        muted
                        loop
                        playsInline
                    /> */}
                <HeroBanner filePath={`${config.BASE_URL}${facadeContent?.hero?.vedioUrl}`} />
                </picture>
            </div>
            <div className="text-with-text-block lighting-facade-banner banner-overlap position-relative z-2 pb-60 d-pb-100">
                <div className='container'>
                    <div className="grid-blocks d-grid align-center large-small gap-30 d-gap-50">
                        <div className="grid-block grid-left d-flex flex-column gap-20 d-gap-50">
                            <div className="summary-block">
                                <Link to="/"><img src={Logo} alt="Site Logo" /></Link>
                                {/* <div className='title-block mt-20 mb-50'><h1>{content.hero.title}</h1></div> */}
                                <div className='title-block mt-20 mb-50'><h1>{facadeContent?.hero?.title}</h1></div>

                                <div className='text-block heading-font-family font-size-24 fw-400 mb-20'>{content?.hero?.subtitle}</div>
                                {facadeContent?.hero?.paragraphs.map((p, idx) => (
                                    <p key={idx}>{p}</p>
                                ))}
                            </div>
                        </div>
                        <div className="grid-block grid-right">
                            <div className='grid-block d-mt-10 '>
                                <ul>
                                    <li className='d-flex justify-end mb-10'><Link to='/about' className='button'>{content.navigation.aboutUs}</Link></li>
                                    <li className='d-flex justify-end'><Link to='/about#team' className='button'>{content.navigation.ourTeam}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-banner image-banner hero-banner color-light d-flex flex-column justify-end gap-30 d-gap-50 full-screen position-relative bottom-overlay">
                <picture className="cover position-absolute top-0 start-0">
                    <source media="(max-width:768px)" srcSet={textBanner} />
                    <img className="cover" src={`${config.BASE_URL}${facadeContent?.textBanner?.ImageUrl}`} alt="" />
                </picture>
                <div className='container position-relative z-2'>
                    <div className="summary-block">
                        <div className='text-block heading-font-family font-size-24 fw-400 mb-20'>{facadeContent?.textBanner?.title}</div>
                        {facadeContent?.textBanner?.paragraphs.map((p, idx) => (
                            <p key={idx}>{p}</p>
                        ))}
                    </div>
                </div>
            </div>


            {featuredProject?.length > 0 ? <>
                <FeaturedProperties2 customclasses='py-20 d-pt-50 pb-50 d-pb-100 color-light border-bottom' properties={featuredProject} data='1' />
            </> : <></>}


            <div className="image-banner interactive-facade-banner small-banner d-flex flex-column justify-end gap-30 d-gap-50 full-screen position-relative bottom-overlay">
                <picture className="cover position-absolute top-0 start-0">
                    <source media="(max-width:768px)" srcSet={smallBanner} />
                    <img className="cover" src={`${config.BASE_URL}${facadeContent?.section3?.ImageUrl}`} alt="" />
                </picture>
            </div>
            <div className="text-with-text-block interactive-facade-banner-content lighting-facade-banner banner-overlap position-relative z-2">
                <div className='container'>
                    <div className="grid-blocks d-grid align-center large-small gap-30 d-gap-50">
                        <div className="grid-block grid-left d-flex flex-column gap-20 d-gap-50">
                            <div className="summary-block">
                                {/* <div className='title-block mt-20 mb-50'><h1>Bespoke facade lighting design</h1></div> */}
                                <div className='text-block heading-font-family font-size-24 fw-400 mb-20'>{facadeContent?.section3?.title}​</div>
                                <div className='d-flex align-center gap-20 mb-30'><Link to="/"><img src={Logo} alt="Site Logo" /></Link> <span className='h3 fw-200 mb-0'>X</span> <img src={collabPartner} className='collab-partner-image' /></div>
                                {/* <p>Working in collaboration with Claudia Paz Lighting Studio, a creative firm known for merging light, art, technology, and interaction - Luminicos brings technical depth and hands - on experience to every phase of project execution.</p>
                                <p>While Claudia Paz and her team focus on concept, design and immersive storytelling, Luminicos ensures the design is deliverable: specifying appropriate products, optimizing budgets through value engineering, supporting installation on site, and overseeing commissioning. ​</p>
                                <p>Together, we help bring façade lighting concepts to life—transforming buildings and skylines with precision, creativity, and reliability.</p> */}
                                {facadeContent?.section3?.paragraphs.map((p, idx) => (
                                    <p className='mb-0' key={idx}>{p}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {featuredProject?.length >= 2 ? <>
                <FeaturedPropertiesVideos customclasses='lighting-facade-page pb-50 d-pb-100 color-light border-bottom' properties={featuredProject} data='2' />
            </> : <></>}

            <div className='single-property-section'>
                <div className='container'>
                    <div className='single-property-wrapper d-ps-30'>
                        {featuredProject?.length >= 1 ? <>
                            <FeaturedPropertiesVideos customclasses='lighting-facade-page pb-50 d-pb-100 color-light border-bottom' properties={featuredProject} data='1' />
                        </> : <></>}
                    </div>
                </div>
            </div>

            <div className="text-banner image-banner hero-banner color-light d-flex flex-column justify-end gap-30 d-gap-50 full-screen position-relative bottom-overlay pb-50">
                <picture className="cover position-absolute top-0 start-0">
                    <source media="(max-width:768px)" srcSet={smallBanner2} />
                    <img className="cover" src={`${config.BASE_URL}${facadeContent?.textBanner2?.ImageUrl}`} alt="" />
                </picture>
                <div className='container position-relative z-2'>
                    <div className="summary-block">
                        <div className='text-block heading-font-family font-size-24 fw-400 mb-20'>{facadeContent?.textBanner2?.title}</div>
                        {facadeContent?.textBanner2?.paragraphs.map((p, idx) => (
                            <p className='mb-0' key={idx}>{p}</p>
                        ))}

                    </div>
                </div>
            </div>

            {/* {featuredProject?.length >= 2 ? <> */}
            <FeaturedPropertiesVideos2 customclasses='lighting-facade-page pb-50 d-pb-100 color-light border-bottom' properties={featuredProject} data='2' />
            {/* </> : <></>} */}

            <div className='large-property-with-text pb-60 d-pb-100'>
                <div className='container'>
                    <div className='grid-blocks d-grid large-small gap-50 d-gap-100'>
                        <div className='grid-block left-block'>
                            {/* Show large property here */}

                            <FeaturedPropertiesVideosDisclaimer customclasses='lighting-facade-page pb-50 d-pb-100 color-light border-bottom' properties={featuredProject} data='1' file={facadeContent?.disclaimer?.VideoUrl} />


                        </div>
                        <div className='grid-block right-block d-flex align-center'>
                            <div className='summary-block'>
                                <div className='h6'>{facadeContent?.disclaimer?.title}</div>
                                <div className='text-block font-size-10'>{facadeContent?.disclaimer?.text}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='what-we-offer-section pt-60 d-pt-120 pb-60 d-pb-120 border-top border-light-2'>
                <div className='container'>
                    <div className='section-heading pb-30 d-pb-60'>
                        <div className='h2 font-size-24'>{content.sections.ourProcess}</div>
                    </div>
                    <div className="offer-blocks d-grid d-column-2 gap-50 d-gap-70 d-row-gap-50">
                        {content.process?.map((item, index) => (
                            <div className="offer-block" key={index}>
                                <div className="offer-head d-flex align-center gap-20 d-gap-30">
                                    <div className="icon-box d-flex align-center justify-center"><img src={processIcons[item.icon]} alt='item.icon' /></div>
                                    <div className="title-block font-size-24 fw-200 d-mb-20">{item.title}</div>
                                </div>
                                <div className="summary-block pt-10 d-ps-80">{item.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className='our-partner-section py-60 d-py-100 border-top border-light-2'>
                <div className='container'>
                    <div className='section-heading pb-30 d-pb-40'>
                        <div className='h2 font-size-24'>Our Partners</div>
                    </div>
                    <div className='our-partner-logos d-flex flex-wrap gap-40'>
                        {partners.map((partner) => (
                            <div
                                key={partner.id}
                                className="logo-block"
                            >
                                <img
                                    src={partner.logo}
                                    className=""
                                />
                            </div>
                        ))}

                    </div>
                </div>
            </div>

        </Layout>
    )
}

export default LightingFacade